import {BOARD_ID} from '@/util/BoardConst';

const MY_BID = {
  MAIN_SLIDER: BOARD_ID.BID_PODO_MAIN_SLIDER,
  NOTICE: BOARD_ID.BID_PODO_NOTICE,
  PHOTO: BOARD_ID.BID_PODO_PHOTO,
  NEWSROOM: BOARD_ID.BID_PODO_NEWSROOM,
  SPECIAL_OFFER: BOARD_ID.BID_PODO_SPECIAL_OFFER,
  RESTAURANT: BOARD_ID.BID_PODO_RESTAURANT,
  POPUP: BOARD_ID.BID_PODO_POPUP,
};

export default MY_BID;
